"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const react_1 = tslib_1.__importStar(require("react"));
const react_if_1 = require("react-if");
const Badge_1 = tslib_1.__importDefault(require("reactstrap/lib/Badge"));
const context_1 = require("../../../context");
const reusables_1 = require("../../../comps/reusables");
const routeContainers_1 = require("../../../comps/routeContainers");
const graphql_1 = require("../../../graphql");
const Invites_1 = tslib_1.__importDefault(require("./Invites"));
const Nav_1 = require("./Nav");
const Profile_1 = tslib_1.__importDefault(require("./Profile"));
const OsmosysResourcePage_1 = require("../../../comps/reusables/OsmosysResourcePage");
const UserDetailAdminSettings_1 = require("./UserDetailAdminSettings");
const use_react_router_1 = tslib_1.__importDefault(require("use-react-router"));
exports.UserDetail = ({ basePath = '/admin/users/:id', }) => {
    const { match } = use_react_router_1.default();
    const { currentUser, adminRole } = react_1.useContext(context_1.OsmosysAppContext);
    return (react_1.default.createElement(reusables_1.OsmosysResourcePage, { query: graphql_1.user, paths: {
            item: 'user',
        }, getNav: () => {
            return (react_1.default.createElement(Nav_1.Nav, { userId: match.params.id, basePath: basePath, activeTab: "" }));
        }, variables: { id: match.params.id || currentUser.id }, getTitle: data => (react_1.default.createElement(react_if_1.When, { condition: !!data.user }, () => (react_1.default.createElement(react_1.default.Fragment, null,
            adminRole === 'app' && data.user.isAppAdmin && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("small", null,
                    react_1.default.createElement(Badge_1.default, { color: "danger", style: { fontSize: 12, marginBottom: 5 } }, "Osmosys Admin")),
                react_1.default.createElement("br", null))),
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faUserCircle, className: "mr-2" }),
            data.user.fullName || data.user.email)))), getSubTitle: data => data.user && data.user.fullName && data.user.email },
        react_1.default.createElement(OsmosysResourcePage_1.OsmosysResourcePageInner, null, data => (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(routeContainers_1.OsmosysRoute, { exact: true, path: basePath, component: Profile_1.default, componentProps: {
                    user: data.user,
                } }),
            react_1.default.createElement(routeContainers_1.OsmosysRoute, { exact: true, path: `${basePath}/admin`, component: UserDetailAdminSettings_1.UserDetailAdminSettings, componentProps: {
                    user: data.user,
                }, access: "admin" }),
            react_1.default.createElement(routeContainers_1.OsmosysRoute, { path: `${basePath}/invites`, component: Invites_1.default, componentProps: {
                    user: data.user,
                }, access: "admin" }))))));
};
exports.default = exports.UserDetail;
//# sourceMappingURL=index.js.map